import React from 'react';
import PropTypes from 'prop-types';
import Authorization from '../Authorization';
import Lock from '../Lock';
import { ADMIN_ROLE, THEATER_ADMIN_ROLE, FREE_PLAN } from '../../constants';
import getTranslation from '../../utils/GetTranslation';

class ProductionUser extends React.PureComponent {
  render() {
    return (
      <span className={`smallest-span ${this.props.className}`}>
        {this.props.value.name}/{getTranslation(this.props.value.name)}:&nbsp;
        <Authorization
          deniedPlans={[FREE_PLAN]}
          allowed={[THEATER_ADMIN_ROLE, ADMIN_ROLE]}
        >
          <span style={{ paddingLeft: '5px' }}>{this.props.value.value}</span>
        </Authorization>
        <Authorization allowed={['guest']}>
          <Lock />
        </Authorization>
        <Authorization allowedPlans={[FREE_PLAN]}>
          <Lock />
        </Authorization>
        
      </span>
    );
  }
}

ProductionUser.propTypes = {
  value: PropTypes.object,
  className: PropTypes.string
};

ProductionUser.defaultProps = {
  value: {},
  className: ''
};

export default ProductionUser;



// WEBPACK FOOTER //
// ./src/components/Production/ProductionUser.js